export const ADMIN_AUTOMATIC_USER_ALLOCATION = 'ADMIN_AUTOMATIC_USER_ALLOCATION';
export const ADMIN_BRANDING = 'ADMIN_BRANDING';
export const ADMIN_CANCEL_OFFERS = 'ADMIN_CANCEL_OFFERS';
export const ADMIN_APPROVAL_TYPES = 'ADMIN_APPROVAL_TYPES';
export const ADMIN_COMPETENCE_ORDERS = 'ADMIN_COMPETENCE_ORDERS';
export const ADMIN_DICTIONARIES = 'ADMIN_DICTIONARIES';
export const ADMIN_DICTIONARIES_WRITE = 'ADMIN_DICTIONARIES_WRITE';
export const ADMIN_CITIES_READ = 'ADMIN_CITIES_READ';
export const ADMIN_CITIES_WRITE = 'ADMIN_CITIES_WRITE';
export const ADMIN_TAX_RATES_READ = 'ADMIN_TAX_RATES_READ';
export const ADMIN_TAX_RATES_WRITE = 'ADMIN_TAX_RATES_WRITE';
export const ADMIN_INCOME_SOURCES = 'ADMIN_INCOME_SOURCES';
export const ADMIN_AUTOMATIC_STATE_TRANSITIONS = 'ADMIN_AUTOMATIC_STATE_TRANSITIONS';
export const ADMIN_DOCUMENTS_CHECKLIST = 'ADMIN_DOCUMENTS_CHECKLIST';
export const ADMIN_GENERIC_ENTITY_FLOW_CHECKLIST = 'ADMIN_GENERIC_ENTITY_FLOW_CHECKLIST';
export const ADMIN_CLAUSE_DOCUMENT = 'ADMIN_CLAUSE_DOCUMENT';
export const ADMIN_DOCUMENT_SIGN_STATE_TRANSITIONS = 'ADMIN_DOCUMENT_SIGN_STATE_TRANSITIONS';
export const ADMIN_DOCUMENT_TEMPLATES = 'ADMIN_DOCUMENT_TEMPLATES';
export const ADMIN_DOCUMENT_TYPES = 'ADMIN_DOCUMENT_TYPES';
export const ADMIN_REQUIRED_DOCUMENTS = 'ADMIN_REQUIRED_DOCUMENTS';
export const ADMIN_SYNC_DOCUMENT_STATE = 'ADMIN_SYNC_DOCUMENT_STATE';
export const ADMIN_TASKS = 'ADMIN_TASKS';
export const ADMIN_MONITORING = 'ADMIN_MONITORING';
export const ADMIN_ATLAS = 'ADMIN_ATLAS';
export const ADMIN_ICE = 'ADMIN_ICE';
export const ADMIN_ANAF_QUERY_CLIENT = 'ADMIN_ANAF_QUERY_CLIENT';
export const ADMIN_QUESTIONNAIRES = 'ADMIN_QUESTIONNAIRES';
export const ADMIN_REPORTS = 'ADMIN_REPORTS';
export const ADMIN_VERIFICATION_REPORTS = 'ADMIN_VERIFICATION_REPORTS';
export const ADMIN_SCORING = 'ADMIN_SCORING';
export const ADMIN_ASSET_HIERARCHY = 'ADMIN_ASSET_HIERARCHY';
export const ADMIN_PARTNER_TYPES_READ = 'ADMIN_PARTNER_TYPES_READ';
export const ADMIN_PARTNER_TYPES_WRITE = 'ADMIN_PARTNER_TYPES_WRITE';
export const ADMIN_CONSENTS_ON_PARTNER_TYPES = 'ADMIN_CONSENTS_ON_PARTNER_TYPES';
export const ADMIN_INITIALIZATION_PARAMETERS = 'ADMIN_INITIALIZATION_PARAMETERS';
export const ADMIN_INITIALIZATION_PARAM_WRITE = 'ADMIN_INITIALIZATION_PARAM_WRITE';
export const ADMIN_SECURITY = 'ADMIN_SECURITY';
export const ADMIN_VERIFICATION_TYPES = 'ADMIN_VERIFICATION_TYPES';
export const ADMIN_TEXT_RESOURCES = 'ADMIN_TEXT_RESOURCES';
export const ADMIN_GENERIC_EVALUATION = 'ADMIN_GENERIC_EVALUATION';
export const ADMIN_EXCHANGE_RATES = 'ADMIN_EXCHANGE_RATES';
export const ADMIN_PROPERTIES_READ = 'ADMIN_PROPERTIES_READ';
export const ADMIN_PROPERTIES_WRITE = 'ADMIN_PROPERTIES_WRITE';
export const ADMIN_GENERIC_FILTER_PARAMS_READ = 'ADMIN_GENERIC_FILTER_PARAMS_READ';
export const ADMIN_GENERIC_FILTER_PARAMS_WRITE = 'ADMIN_GENERIC_FILTER_PARAMS_WRITE';
export const ADMIN_FINANCIAL_PRODUCT_READ = 'ADMIN_FINANCIAL_PRODUCT_READ';
export const ADMIN_FINANCIAL_PRODUCT_WRITE = 'ADMIN_FINANCIAL_PRODUCT_WRITE';
export const ADMIN_ACCOUNT_STATEMENT_READ = 'ADMIN_ACCOUNT_STATEMENT_READ';
export const ADMIN_ACCOUNT_STATEMENT_WRITE = 'ADMIN_ACCOUNT_STATEMENT_WRITE';
export const ADMIN_INSURANCE_CONVENTIONS_READ = 'ADMIN_INSURANCE_CONVENTIONS_READ';
export const ADMIN_INSURANCE_CONVENTIONS_WRITE = 'ADMIN_INSURANCE_CONVENTIONS_WRITE';
export const ADMIN_ITEMS_WRITE = 'ADMIN_ITEMS_WRITE';
export const ADMIN_ITEMS_READ = 'ADMIN_ITEMS_READ';
export const ADMIN_LEASING_INTERESTS_READ = 'ADMIN_LEASING_INTERESTS_READ';
export const ADMIN_LEASING_INTERESTS_WRITE = 'ADMIN_LEASING_INTERESTS_WRITE';
export const ADMIN_LEASING_SERVICE_TYPES_READ = 'ADMIN_LEASING_SERVICE_TYPES_READ';
export const ADMIN_LEASING_SERVICE_TYPES_WRITE = 'ADMIN_LEASING_SERVICE_TYPES_WRITE';
export const ADMIN_RESIDUAL_VALUE_GRIDS_READ = 'ADMIN_RESIDUAL_VALUE_GRIDS_READ';
export const ADMIN_RESIDUAL_VALUE_GRIDS_WRITE = 'ADMIN_RESIDUAL_VALUE_GRIDS_WRITE';
export const ADMIN_LEASING_INCOME_SCHEMAS_READ = 'ADMIN_LEASING_INCOME_SCHEMAS_READ';
export const ADMIN_LEASING_INCOME_SCHEMAS_WRITE = 'ADMIN_LEASING_INCOME_SCHEMAS_WRITE';
export const ADMIN_LEASING_EXPENSE_TYPES_READ = 'ADMIN_LEASING_EXPENSE_TYPES_READ';
export const ADMIN_LEASING_EXPENSE_TYPES_WRITE = 'ADMIN_LEASING_EXPENSE_TYPES_WRITE';
export const ADMIN_GENERIC_FILTER_TEMPLATES_READ = 'ADMIN_GENERIC_FILTER_TEMPLATES_READ';
export const ADMIN_GENERIC_FILTER_TEMPLATES_WRITE = 'ADMIN_GENERIC_FILTER_TEMPLATES_WRITE';
export const ADMIN_COMMISSIONS_READ = 'ADMIN_COMMISSIONS_READ';
export const ADMIN_COMMISSIONS_WRITE = 'ADMIN_COMMISSIONS_WRITE';
export const ADMIN_COMMISSION_CALCULATION_METHOD_READ = 'ADMIN_COMMISSION_CALCULATION_METHOD_READ';
export const ADMIN_COMMISSION_CALCULATION_METHOD_WRITE = 'ADMIN_COMMISSION_CALCULATION_METHOD_WRITE';
export const ADMIN_FIELD_DECIMAL_PLACES_CONFIG_READ = 'ADMIN_FIELD_DECIMAL_PLACES_CONFIG_READ';
export const ADMIN_FIELD_DECIMAL_PLACES_CONFIG_WRITE = 'ADMIN_FIELD_DECIMAL_PLACES_CONFIG_WRITE';
export const ADMIN_USER_GROUPS_READ = 'ADMIN_USER_GROUPS_READ';
export const ADMIN_USER_GROUPS_WRITE = 'ADMIN_USER_GROUPS_WRITE';
export const ADMIN_SCHEDULES_READ = 'ADMIN_SCHEDULES_READ';
export const ADMIN_SCHEDULES_WRITE = 'ADMIN_SCHEDULES_WRITE';
export const ADMIN_DMS_READ = 'ADMIN_DMS_READ';
export const ADMIN_DMS_WRITE = 'ADMIN_DMS_WRITE';
export const ADMIN_NON_WORKING_DAYS_READ = 'ADMIN_NON_WORKING_DAYS_READ';
export const ADMIN_NON_WORKING_DAYS_WRITE = 'ADMIN_NON_WORKING_DAYS_WRITE';
export const MASTER_PARTNER_READ = 'MASTER_PARTNER_READ';
export const ADMIN_DOCUMENT_TYPE_PROPERTIES_READ = 'ADMIN_DOCUMENT_TYPE_PROPERTIES_READ';
export const ADMIN_DOCUMENT_TYPE_PROPERTIES_WRITE = 'ADMIN_DOCUMENT_TYPE_PROPERTIES_WRITE';
